
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class OrderWarningModel extends Model<OrderWarningModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'orderId', type: 'string' },
		{ name: 'comment', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'createdById', type: 'string' },
		{ name: 'closed', type: 'Date' },
		{ name: 'closedById', type: 'string' },
		{ name: 'reasonId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'reason', type: 'ReasonModel', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public comment: string;
	public created?: Date;
	public createdById?: string;
	public closed?: Date;
	public closedById?: string;
	public reasonId?: string;
	public taskflowId?: string;
	public order?: OrderModel;
	public reason?: ReasonModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.comment = '';
		this.created = undefined;
		this.createdById = undefined;
		this.closed = undefined;
		this.closedById = undefined;
		this.reasonId = undefined;
		this.taskflowId = undefined;
		this.order = undefined;
		this.reason = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return OrderWarningModel.classProperties;
	}
}

